// extracted by mini-css-extract-plugin
export default {"V2PieChartWrap":"V2PieChartWrap--pRFOe","V2PieChart":"V2PieChart--MPdHj"};